import { MiReorderButton } from "@miplatform/components";
import { IStepTemplateResponse } from "@miplatform/types";
import { Box } from "@mui/material";
import { ConfigCard } from "../../components";

export const ConfigWorkOrderStepCard = ({
  step,
  index,
  disableUp,
  disableDown,
  onReorderUp,
  onReorderDown,
}: {
  step: IStepTemplateResponse;
  index: number;
  disableUp: boolean;
  disableDown: boolean;
  onReorderUp: () => void;
  onReorderDown: () => void;
}) => {
  const { title, modifiedOn, stepType } = step || {};

  return (
    <Box display="flex" alignItems="center" width="100%" gap={2}>
      <ConfigCard
        title={title}
        modifiedOn={modifiedOn}
        additionalTitleText={stepType ? [stepType] : []}
      />
      <MiReorderButton
        onMoveUp={onReorderUp}
        onMoveDown={onReorderDown}
        disableUp={disableUp}
        disableDown={disableDown}
      />
    </Box>
  );
};
